import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
// -------Angular Material------------------------------------
import { MatSort } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../shared-components/angular-material/mat-animations';
import { Student } from '../../shared-components/student/student.model';
// ---------Shared--------------------------------------------
import { StudentService } from '../../shared-components/student/student.service';
import { UserService } from '../../shared-components/user/user.service';
import { Year } from '../../shared-components/year/year.model';
import { YearService } from '../../shared-components/year/year.service';
import { LoginService } from '../../shared-modules/login/login.service';
import { Transportation } from './transportation.model';
import { TransportationService } from './transportation.service';



@Component({
    selector: 'transportation',
    templateUrl: './transportation.component.html',
    styleUrls: ['./transportation.component.scss'],
    animations: [detailExpand]
})
export class TransportationComponent implements OnInit, AfterViewInit, OnDestroy {

    // ------------Transportation Data---------------------------
    student360YearSubscription: Subscription;
    student360Year: Year;
    selectedStudentSubscription: Subscription;
    selectedStudent: Student;
    transportation: Transportation[] = [];
    // ------------Selection/Flags-----------------------------------
    selected = '0';
    v10: boolean;
    isBusy: boolean;
    showTraversaBusRoute: boolean;
    traversaEnabled: boolean;
    versatransEnabled: boolean;
    showErrorMessage = false;
    errorMessage = '';
    // ----------Angular Material------------------------------------
    angularMatData = new TylerMatTableDataSource();
    @ViewChild(MatSort) sort: MatSort;
    columnsToDisplay: string[] = ['More', 'Days', 'Destination', 'PickUp', 'PickUpLocation', 'PickUpBus', 'DropOff', 'DropOffLocation', 'DropOffBus'];
    columnsToDisplayTyler: string[] = ['Destination', 'AddressType', 'InBoundBus', 'InBoundRoute', 'InBoundStop', 'InBoundStopTime', 'OutBoundBus', 'OutBoundRoute', 'OutBoundStop', 'OutBoundStopTime'];
    initialSelection = [];
    allowMultiSelect = true;
    detailPadding = 0;
    pickUpPadding = 0;
    selection = new SelectionModel<any>(this.allowMultiSelect, this.initialSelection);
    @ViewChildren('headerTest') matHeaderCellRef: QueryList<ElementRef>;

    @ViewChild('more', { read: ElementRef }) moreRef: ElementRef;
    @ViewChild('days', { read: ElementRef }) daysRef: ElementRef;
    @ViewChild('destination', { read: ElementRef }) destinationRef: ElementRef;

    @ViewChild('pickUpTime', { read: ElementRef }) pickUpTimeRef: ElementRef;
    @ViewChild('pickUpLocation', { read: ElementRef }) pickUpLocationRef: ElementRef;
    @ViewChild('pickUpBus', { read: ElementRef }) pickUpBusRef: ElementRef;
    // --------------LifeCycle---------------------------------------

    constructor(private studentService: StudentService,
        private yearService: YearService,
        private userService: UserService,
        private loginService: LoginService,
        private transportationService: TransportationService) {

        this.selectedStudentSubscription = studentService.selectedStudentStream$.subscribe(
            studentId => {
                this.loadStudentInfo(studentId);
            });
        this.student360YearSubscription = yearService.observableStudent360YearStream$.subscribe(
            student360Year => {
                this.getStudentTransportation();
            }
        );

        this.angularMatData = new TylerMatTableDataSource(this.transportation);

        this.v10 = userService.currentUser.V10;
        this.showTraversaBusRoute = loginService.LoginSettings.ShowTraversaBusRoute;
        this.traversaEnabled = loginService.LoginSettings.TraversaEnabled;
        this.versatransEnabled = loginService.LoginSettings.VersatransEnabled;

        if (!this.loginService.LoginSettings.ShowTraversaBusRoute) {
            this.removeElement(this.columnsToDisplay, 'More');
        }
        if (!this.loginService.LoginSettings.ShowTraversaBusNumber) {
            this.removeElement(this.columnsToDisplay, 'PickUpBus');
            this.removeElement(this.columnsToDisplay, 'DropOffBus');
        }

    }

    ngOnInit() {
        this.loadStudentInfo(this.studentService.selectedStudent.Id);
    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {
        this.selectedStudentSubscription.unsubscribe();
        this.student360YearSubscription.unsubscribe();
    }

    // ------------Student Discipline Data---------------------------

    loadStudentInfo(studentId: number) {
        this.selectedStudent = this.studentService.students.filter(s => s.Id == studentId)[0];
        this.getStudentTransportation();
    }

    getStudentTransportation() {
        this.showErrorMessage = false;
        this.errorMessage = '';
        this.isBusy = true;

        if (this.selectedStudent && this.studentService.studentEnrollment) {
            this.transportationService.getTransportation(this.selectedStudent.Id, this.yearService.student360Year.Id, this.studentService.studentEnrollment.SchoolId).subscribe(result => {
                if (result.length == 1 && result[0].Id == -99) {
                    this.showErrorMessage = true;
                    this.errorMessage = result[0].ErrorMessage != null ? result[0].ErrorMessage : '';
                }
                else {
                    this.transportation = result;
                }

                if (this.versatransEnabled || this.traversaEnabled) {
                    this.student360Year = this.yearService.student360Year;
                }

                this.loadStudentTransportation();
            });
        }
    }

    private loadStudentTransportation(): void {
        this.angularMatData.data = this.transportation;
        this.angularMatData.sort = this.sort;
        this.isBusy = false;
    }

    // ------------Helper methods----------------------------------
    getPadding() {
        setTimeout(() => {
            this.detailPadding = this.destinationRef.nativeElement.offsetWidth + this.moreRef.nativeElement.offsetWidth + this.daysRef.nativeElement.offsetWidth - 100;
            this.pickUpPadding = this.pickUpTimeRef.nativeElement.offsetWidth + this.pickUpLocationRef.nativeElement.offsetWidth + this.pickUpBusRef.nativeElement.offsetWidth - 125;
        }, 0);
    }

    // ----------Angular Material------------------------------------
    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.getPadding();
    }

    removeElement(array: any[], element: any) {
        const index: number = array.indexOf(element);
        array.splice(index, 1);
    }

    // ------------Aria/Accessibility---------------------------

    getAriaRow(row: any): string {
        // Returns string for a given row's data
        // reads each column header name and then the cell data for that column


        return '';
    }

    // ----------Angular Material------------------------------------
    toggleExpanded(row: any) {
        if (this.pickUpPadding == 0 || this.detailPadding == 0) {
            this.getPadding();
        }
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.angularMatData.expandAll(expand);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);
    }
}
